import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CarIcon from '../../../icons/car.svg';
import { object, string } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { StyledRadioInput, SelectInput } from '../../Helpers/Inputs';
import { ThemeProvider, createTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import InputTheme from './Helpers/InputTheme';
import { SvgIcon } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import "./DrivingRecord.scss";

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#000000DB',
  },
  lightBackground: {
      backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

export default function DrivingRecord(props) {

  const classes = useStyles();

  const { register, handleSubmit, setValue, errors, triggerValidation } = useForm({
    validationSchema: DrivingRecord.ValidationSchema(),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'movingViolations' });
    setValue('movingViolations', props.formState.movingViolations);

    register({ name: 'recklessDriving' });
    setValue('recklessDriving', props.formState.recklessDriving);

    register({ name: 'DUIOrDWI' });
    setValue('DUIOrDWI', props.formState.DUIOrDWI);

    register({ name: 'movingViolationCount' });
    setValue('movingViolationCount', props.formState.movingViolationCount);

    register({ name: 'recklessDrivingCount' });
    setValue('recklessDrivingCount', props.formState.recklessDrivingCount);

    register({ name: 'DUIOrDWICount' });
    setValue('DUIOrDWICount', props.formState.DUIOrDWICount);
  }, [register])

  const buttonData = [
    {
      name: 'movingViolations',
      value: props.formState.movingViolations,
      title: 'Moving Violations',
      subtitle: 'I have had a moving violation in the last 2 years.',
      dropdownName: 'movingViolationCount',
      dropdownValue: props.formState.movingViolationCount,
      dropdownLabel: 'Number of Moving Violations',
      dropdownOption: [{ label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3 or more", value: "3 or more" }],
      error: errors.movingViolations,
      dropdownerror: errors.movingViolationCount
    },
    {
      name: 'recklessDriving',
      value: props.formState.recklessDriving,
      title: 'Reckless Driving',
      subtitle: 'I have had a reckless driving conviction in the last 10 years.',
      dropdownName: 'recklessDrivingCount',
      dropdownValue: props.formState.recklessDrivingCount,
      dropdownLabel: 'Years since my conviction',
      dropdownOption: [{ label: "Less than 1 year", value: "Less than 1 year" }, { label: "1 – 2 years", value: "1 – 2 years" }, { label: "3 – 5 years", value: "3 – 5 years" }, { label: "6 – 10 years", value: "6 – 10 years" }],
      error: errors.recklessDriving,
      dropdownerror: errors.recklessDrivingCount
    },
    {
      name: 'DUIOrDWI',
      value: props.formState.DUIOrDWI,
      title: 'DUI/DWI',
      subtitle: 'I have had a DUI/DWI conviction in the last 10 years.',
      dropdownName: 'DUIOrDWICount',
      dropdownValue: props.formState.DUIOrDWICount,
      dropdownLabel: 'Years since my conviction',
      dropdownOption: [{ label: "Less than 1 year", value: "Less than 1 year" }, { label: "1 – 2 years", value: "1 – 2 years" }, { label: "3 – 5 years", value: "3 – 5 years" }, { label: "6 – 10 years", value: "6 – 10 years" }],
      error: errors.DUIOrDWI,
      dropdownerror: errors.DUIOrDWICount
    },
  ]

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...InputTheme(),
    })}>
      <Container className='driving-record personalize-step'>
        <Row className="justify-content-center pt-2">
          <div className={`icon-container ${classes.lightBackground}`}>
            <SvgIcon component={CarIcon} fontSize="large" color="primary" />
          </div>
        </Row>
        <Row className="justify-content-center mainTitle">
          <h4>Driving Record</h4>
        </Row>
        <Form onSubmit={handleSubmit(props.onNext)} >
          <Row className="justify-content-center pt-2 form-profile" role="group" aria-labelledby="Select Personalizing Options" >
            {buttonData.map((d, index) =>
              <Col md='auto' key={index} className='driving-background'>
                <Row className="px-4 pt-3">
                  <h5 className={classes.sectionTitle}>{d.title}</h5>
                </Row>
                <Row className="px-4 py-1">
                  <p className="formElementTitle">{d.subtitle}</p>
                </Row>
                <Form.Group className='pt-2 mb-0'>
                  <StyledRadioInput
                    name={d.name}
                    id={d.name}
                    value={d.value}
                    index={index}
                    inputRef={register}
                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                    onChange={(e) => handleValueChange(d.name, e)}
                    errors={d.error}
                    isBlankIcon={true}
                  />
                </Form.Group>
                {d.value === 'Yes' &&
                  <Form.Group>
                    <SelectInput
                      name={d.dropdownName}
                      id={d.dropdownName}
                      value={d.dropdownValue}
                      onChange={(e) => handleValueChange(d.dropdownName, e.target.value)}
                      inputRef={register}
                      label={d.dropdownLabel}
                      selectOptions={d.dropdownOption}
                      errors={d.dropdownerror}
                    />
                  </Form.Group>
                }
              </Col>
            )}
          </Row>
          <Row className="pre-quote-nav-control">
            <Col className="text-left btn-back">
              <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack} >BACK</Button>
            </Col>
            <Col className="text-right">
              <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">NEXT</Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </ThemeProvider>
  );
}

DrivingRecord.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

DrivingRecord.ValidationSchema = () => {
  return object().shape({
    movingViolations: string().required('This field is required.'),
    movingViolationCount: string().when('movingViolations', {
      is: 'Yes',
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    recklessDriving: string().required('This field is required.'),
    recklessDrivingCount: string().when('recklessDriving', {
      is: 'Yes',
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
    DUIOrDWI: string().required('This field is required.'),
    DUIOrDWICount: string().when('DUIOrDWI', {
      is: 'Yes',
      then: string()
        .required('This field is required.'),
      otherwise: string().notRequired()
    }),
  })
};

DrivingRecord.DefaultFormState = () => {
  return {
    movingViolations: 'No',
    recklessDriving: 'No',
    DUIOrDWI: 'No',
    movingViolationCount: '',
    recklessDrivingCount: '',
    DUIOrDWICount: '',
  };
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/DrivingRecord.js